import { Component, OnInit } from '@angular/core';
import { TooltipService } from '../../../widgets/tooltip.service';
import { AHRService, AuthenticatedIdentity, AuthenticationService, CurrentUser, Option } from 'app/domain';
import { Router } from '@angular/router';

interface AHRYearData {
  value: string;
  displayValue: string;
}

@Component({
  selector: 'reviewer-my-review',
  templateUrl: './reviewer-my-review.component.html',
  styleUrls: ['./reviewer-my-review.component.scss']
})
export class ReviewerMyReviewComponent implements OnInit {

  currentUser: Option<CurrentUser> = Option.create<CurrentUser>();
  selectedAHRYear: string = 'ALL';
  showCaseList = false;
  ahrYears: AHRYearData[] = [{value: 'ALL', displayValue: 'ALL'}];

  constructor(
    public tooltipSvc: TooltipService,
    private authsvc: AuthenticationService,
    private svc: AHRService,
    private router: Router) {

        authsvc.currentIdentity.subscribe(identity => {
          identity.match(
            () => {
              this.currentUser = Option.create<CurrentUser>();
            },
            (i: AuthenticatedIdentity) => {
              this.currentUser = Option.create<CurrentUser>(i.user);
            });
        });

        let maxYear = new Date().getFullYear() + 5;
        for(let y = maxYear; y > maxYear - 10; y--)
        {
          this.ahrYears.push({value: y.toString(), displayValue: y.toString() + '-' + (y+1).toString()});
        }
   }

  ngOnInit() {
    this.svc.getCurrentPeriodOfReviewYear().then(year => {
      this.selectedAHRYear = year ?? 'ALL';
      this.refreshComponent(year);
    });
  }

  getInstructions(): string {
    return this.tooltipSvc.tooltip("WFAPBIngtigrationInstructions.REVIEWER");
  }

  refreshComponent(year: string) {
    this.router.navigate(['/review/my-review']);
    this.selectedAHRYear = year;
    this.showCaseList = false;
    setTimeout(() => this.showCaseList = true);  //This refreshes the component
  }

  getReviewRange(year: string): string {
    if (year === 'ALL') {
      return 'ALL';
    }
    const startYear = parseInt(year, 10);
    if (isNaN(startYear)) {
      return year;
    }
    return `${startYear}-${startYear + 1}`;
  }
}
